import { render, staticRenderFns } from "./TotalUsersBlock.vue?vue&type=template&id=d521aa22&"
import script from "./TotalUsersBlock.vue?vue&type=script&lang=ts&"
export * from "./TotalUsersBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TotalUsersBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
